/* eslint-disable */
import { Button } from '@mui/material';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import RHFEditor from 'src/components/elements/Editor/RHFEditor';
import RHFEmailsChips from 'src/components/elements/EmailsChips/RHFEmailsChips';
import RHFInput from 'src/components/elements/Input/RHFInput';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import * as yup from 'yup';
import { SendInternalReferenceLinkProps } from '../../types';
import { Loader } from 'src/components';
import { useState } from 'react';

interface SendRefMailProps {
  emailAddress: Array <string> ;
  subject: string;
  content: string;
}

interface SendInternalRefMailProps {
    jobOrderId: number;
    internalLink: string;
    jobTitle: string;
    location: Array<string>;
    client: string;
    updateShowMail: (val: boolean) => void;
    shareInternalLink?: (data: SendInternalReferenceLinkProps) => Promise<void>;
}

const validationSchema = yup.object().shape({
  emailAddress: yup.array(yup.string().email()).min(1, 'Must have at least 1 email'),
  subject: yup.string().required("subject required"),
  content: yup.string().required("email content required"),
});

const SendInternalRefMail = function SendInternalRefMail(props: SendInternalRefMailProps) {
  const {internalLink, jobOrderId, jobTitle, location, client, updateShowMail, shareInternalLink} = props;

  const [loading, setLoading] = useState<boolean>(false);
  const resolver = useYupValidationResolver(validationSchema);
  const methods = useForm<SendRefMailProps>({
   resolver ,
   defaultValues: {
    content: internalLink,
    subject: `Internal referral mail shared: ${jobTitle} @[${location.join('/ ')}] for ${client}`
   }
  });
  const {
    handleSubmit,
  } = methods;

  const submitHandler: SubmitHandler<SendRefMailProps> = async (data) => {
    const finalData = {
      ...data,
      jobOrderId,
    }
    if(shareInternalLink) {
      setLoading(true);
      await shareInternalLink(finalData);
      updateShowMail(false);
      setLoading(false);
    }
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(submitHandler)} className="bg-white flex flex-col gap-8 my-10 px-5 py-10 border-1 border-[#c3c3c3] border-solid rounded-2xl relative">
        <div className='flex flex-col gap-5'>
            <div className="w-full flex-shrink-0">
            <RHFEmailsChips
                control={methods.control}
                name="emailAddress"
                label="To:"
                placeholder="Emails"
            />
            </div>
            <div className="w-full flex-shrink-0">
            <RHFInput
                control={methods.control}
                name="subject"
                label="Subject:"
                placeholder="Subject"
            />
            </div>
            <div className="w-full flex-shrink-0">
            <RHFEditor
                control={methods.control}
                name="content"
                value={internalLink}
            />
            </div>
        </div>
        <div className="w-full flex  gap-2 ">
          <Button variant="contained" type="submit" size="small" className="font-medium rounded-full">Send</Button>
          <Button variant="outlined" size="small" className="font-medium rounded-full" onClick={()=>updateShowMail(false)}>Cancel</Button>
        </div>
        {loading && (
          <div className="absolute top-[40%] left-[40%]">
            <Loader />
          </div>
        )}
      </form>
    </FormProvider>
  );
};

export default SendInternalRefMail;
